
    import EnderecoIndex from   "./_Index.vue"  
      
    import { Options, Vue  } from "vue-class-component";   
      
    @Options({
        name: "Endereco",
        components: { EnderecoIndex  },  
    }) 
    export default class Endereco extends Vue {
        public modal_cadastro ;
        public model_watch  = false ;
        created(){ 
            this.modal_cadastro = 'kt_cadatrar_endereco_profile';
		}
        public modeloAlterado(){  
             this.model_watch = !this.model_watch;
        }
    }
